import { useState } from "react";
import { AuthPageLayout } from "./auth-page-layout";
import {
  Button,
  FormError,
  FormField,
  PasswordInput,
} from "@/components/ui";

export function ResetPasswordPage() {
  const [password1, setPassword1] = useState("");
  const [password2, setPassword2] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError("");

    if (password1 !== password2) {
      setError("Passwords do not match.");
      return;
    }

    setIsSubmitting(true);
    console.log("[workshop] Reset password submitted:", {
      password1,
      password2,
    });

    setTimeout(() => {
      setIsSubmitting(false);
      setSuccess(true);
    }, 1500);
  }

  return (
    <AuthPageLayout>
      <div className="flex flex-col gap-5">
        <h2
          className="text-2xl font-semibold text-primary"
          data-testid="reset-heading"
        >
          Set new password
        </h2>

        {success ? (
          <div data-testid="reset-success">
            <p className="text-[15px] leading-normal text-secondary">
              Your password has been reset successfully.
            </p>
            <button
              type="button"
              onClick={() => console.log("[workshop] Navigate to login")}
              className="mt-6 inline-block text-[13px] font-semibold text-accent hover:underline"
              data-testid="back-to-login"
            >
              Sign in with your new password
            </button>
          </div>
        ) : (
          <>
            <p className="text-[15px] leading-normal text-secondary">
              Enter your new password below.
            </p>

            <FormError
              message={error}
              className="mt-0"
              data-testid="reset-error"
            />

            <form
              onSubmit={handleSubmit}
              className="flex flex-col gap-5"
              data-testid="reset-form"
            >
              <FormField label="New password" htmlFor="password1">
                <PasswordInput
                  id="password1"
                  required
                  autoComplete="new-password"
                  value={password1}
                  onChange={(e) => setPassword1(e.target.value)}
                  placeholder="New password"
                  className="h-12 rounded-xl text-sm"
                  data-testid="reset-password1"
                />
              </FormField>

              <FormField label="Confirm new password" htmlFor="password2">
                <PasswordInput
                  id="password2"
                  required
                  autoComplete="new-password"
                  value={password2}
                  onChange={(e) => setPassword2(e.target.value)}
                  placeholder="Confirm new password"
                  className="h-12 rounded-xl text-sm"
                  data-testid="reset-password2"
                />
              </FormField>

              <Button
                type="submit"
                variant="secondary"
                size="lg"
                disabled={isSubmitting}
                className="w-full liquid-glass-distortion shadow-glass border-glass-stroke-light font-semibold text-accent"
                data-testid="reset-submit"
              >
                {isSubmitting ? "Resetting..." : "Reset password"}
              </Button>
            </form>
          </>
        )}
      </div>
    </AuthPageLayout>
  );
}
